import { render, staticRenderFns } from "./binding-to-project.vue?vue&type=template&id=5d78cc7f&"
import script from "./binding-to-project.vue?vue&type=script&lang=ts&"
export * from "./binding-to-project.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports